import { useState } from "react";
import { useExams } from "@/hooks/useExam";
import ExamCard from "@/components/exam/ExamCard";

export default function Exams() {
  const [page, _setPage] = useState(1);
  const { data, isLoading, error } = useExams(page);

  return (
    <div className="page-enter mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Mock Exams</h1>
        <p className="mt-2 text-gray-500">
          Choose a mock exam to practice. Each exam has 50 multiple-choice questions with a
          57-minute time limit. You need 43 or more correct answers to pass.
        </p>
      </div>

      {isLoading && (
        <div className="flex items-center justify-center py-20">
          <svg className="animate-spin h-8 w-8 text-primary-600" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
      )}

      {error && (
        <div className="rounded-lg bg-danger-50 border border-danger-200 p-6 text-center">
          <p className="text-danger-700">Failed to load exams. Please try again later.</p>
        </div>
      )}

      {data && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.map((exam) => (
              <ExamCard key={exam.id} exam={exam} />
            ))}
          </div>

          {data.length === 0 && (
            <div className="text-center py-20">
              <svg className="mx-auto h-12 w-12 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              <p className="mt-3 text-gray-500">No exams available yet. Check back soon.</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
